export default __webpack_public_path__ + "static/media/1.67c69871.jpg";